// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, useMediaQuery } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import LocalizationSection from './LocalizationSection';
import { IconMenu2 } from '@tabler/icons-react';
import { dispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

// assets

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();
    const { drawerOpen } = useSelector((state) => state.menu);
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'block', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
            </Box>

            {/* header search */}

            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* mega-menu */}

            {/* live customization & localization */}
            <Box sx={{ display: { xs: 'none', sm: 'block' }, mr: 3 }}>
                <LocalizationSection />
            </Box>

            {/* profile */}
            {matchDownMd ? (
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        overflow: 'hidden',
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.dark,
                        '&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.light
                        }
                    }}
                    onClick={() => dispatch(openDrawer(!drawerOpen))}
                    color="inherit"
                >
                    <IconMenu2 stroke={1.5} size="20px" />
                </Avatar>
            ) : (
                <ProfileSection />
            )}
        </>
    );
};

export default Header;
